import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";


export const getLinkParameters = createAsyncThunk(
  "/parameters/getGeneralParameterByFirm",
  async ({ parameters }, { rejectWithValue }) => {
    try { 
    
      const method = "/parameters/getGeneralParameterByFirm";
 
      const { data, errorMessage, isSuccess } = await commonNetwork.get(method, null);
 
      if (isSuccess) {
        return {data};
      } else {
        return rejectWithValue(errorMessage);
      }
    } catch (e) {
      return rejectWithValue(e.data.message);
    }
  }
);


export const linkParametersSlice = createSlice({
  name: "linkParameters",
  initialState: {  
    defaultSendTypeId : 3,
    linkExpiryDate: 4,
  },
  reducers: { 
    clearState: (state) => {
      state.defaultSendTypeId =3; 
      state.linkExpiryDate =4; 
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLinkParameters.fulfilled, (state, { payload }) => {
       
      state.defaultSendTypeId = payload.data.sendTypeId;
      state.linkExpiryDate = payload.data.linkExpiryDate;
      return state;
    });
    builder.addCase(getLinkParameters.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getLinkParameters.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const {clearState  } = linkParametersSlice.actions;

 

export const linkParametersReducer = linkParametersSlice.reducer;